import { Component } from '@angular/core';

@Component({
  selector: 'app-lightbulb-icon',
  templateUrl: './lightbulb-icon.component.html',
  styleUrl: './lightbulb-icon.component.scss'
})
export class LightbulbIconComponent {

}
